<!--
 * @Description: 用户下拉全局
 * @Author: cxh
 * @Date: 2022-05-07 17:55:14
 * @LastEditTime: 2023-03-08 10:38:46
 * @LastEditors: mdb
-->
<template>
  <CosInputView v-if="view" :mode="mode" :value="viewTxt" />
  <a-select
    v-bind="$attrs"
    v-else
    v-model:value="data"
    :mode="mode"
    style="width: 100%"
    ref="userselect"
    @change="change"
    allowClear
    @popupScroll="popupScroll"
    :showSearch="true"
    :filter-option="false"
    @search="fetchUser"
    :placeholder="placeholder || t('common.pleaseSelect')"
  >
    <a-select-option v-for="item in optionPageComputed" :key="item[fieldNames.value]" :value="item[fieldNames.value]">{{
      `${item.userName}(${item.employeeNo})`
    }}</a-select-option>
  </a-select>
</template>
<script lang="ts" setup>
import { ref, onMounted, watch, computed } from 'vue'
import { listByUsers, fetchUsersByWorkCode } from '@/api/common'
import { debounce, differenceBy, uniqBy } from 'lodash-es'
import { shareInfo } from '@dc-platform/dc-interaction'
import CosInputView from '@/components/Antd/CosView/input.vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const props = defineProps({
  value: {
    type: [String, Number, Array]
  },
  initParams: {
    type: Object,
    default: () => {
      return {}
    }
  },
  fieldNames: {
    type: Object,
    default: () => {
      return { label: 'userName', value: 'employeeNo' }
    }
  },
  placeholder: {
    type: String
  },
  view: {
    type: Boolean
  },
  mode: {
    type: String
  },
  defaultValue: {
    type: String // 设置【me】 默认当前登录人
  },
  // 是否根据登录员工的数据权限查询，默认是false
  permission: {
    type: Boolean,
    default: false
  },
  // 在职状态，【0/1，离职/在职】,不传则查询所有
  status: {
    type: Number
  }
})
const data = ref()
const userselect = ref()
const emit = defineEmits(['update:value', 'change', 'onSelect'])
const optionPage = ref<any[]>([])
const pageNumber = ref(1)
const searchTxt = ref('')
const valueList = ref<any[]>([])
const change = (value: any) => {
  const record = optionPageComputed.value.find((item: any) => item.employeeNo === value)
  emit('update:value', value)
  emit('change', value)
  emit('onSelect', record)
}
const popupScroll = (e: any) => {
  const { scrollHeight, scrollTop, clientHeight } = e.target
  if (scrollHeight - scrollTop === clientHeight) {
    pageNumber.value = pageNumber.value + 1
    fetch()
  }
}
const optionPageComputed = computed(() => {
  if (searchTxt.value) {
    return optionPage.value
  }
  return uniqBy([...valueList.value, ...optionPage.value], 'employeeNo')
})
// 是否请求接口
const needFetchValue = (v: any[]) => {
  if (v && v.length) {
    const vL = v.map((v) => {
      return {
        employeeNo: v
      }
    })
    const valueArr = differenceBy(vL, optionPage.value, 'employeeNo')
    if (valueArr) {
      const employeeList = valueArr.map((item: any) => item.employeeNo)
      fetchUsersByWorkCode({
        employeeList
      }).then((res) => {
        valueList.value = res.data || []
      })
    }
  }
}
// 联系人详情
const viewTxt = computed(() => {
  if (optionPageComputed.value && props.value) {
    const { value } = props.fieldNames
    if (props.mode === 'multiple') {
      if (Array.isArray(props.value)) {
        const result: any = []
        props.value.forEach((val) => {
          const find = optionPageComputed.value.find((item) => item[value] === val)
          if (find) {
            result.push(`${find.userName}(${find.employeeNo})`)
          } else {
            result.push(val)
          }
        })
        return result.join(';') || '--'
      }
      return props.value || '--'
    } else {
      const find = optionPageComputed.value.find((item) => item[value] === props.value)
      if (find) {
        return `${find.userName}(${find.employeeNo})`
      }
      return props.value || '--'
    }
  }
  return props.value
})
// 找到对象值
const getValueObj = (txt: any) => {
  return optionPage.value.find((v) => v[props.fieldNames.value] === txt)
}
const focus = () => {
  userselect.value.focus()
}
defineExpose({
  getValueObj,
  focus
})
onMounted(() => {
  fetch()
  if (props.defaultValue === 'me') {
    const userInfo = shareInfo.getUserInfo() || {}
    if (userInfo.work_code) {
      // data.value = userInfo.work_code
      change(userInfo.work_code)
    }
  }
})
const fetchUser = debounce((txt: string) => {
  // 去掉前后空格
  searchTxt.value = txt.trim()
  optionPage.value = []
  pageNumber.value = 1
  fetch()
}, 500)
const fetch = () => {
  listByUsers({
    pageNumber: pageNumber.value,
    pageSize: 500,
    keyword: searchTxt.value,
    // props.view 详情页的时候需要获取所有数据
    dataRangeQueryFlag: !!(props.view || props.permission),
    status: props.view ? undefined : props.status,
    ...props.initParams
  }).then((res) => {
    if (pageNumber.value === 1) {
      optionPage.value = []
    }
    optionPage.value = [...optionPage.value, ...res.data.items]
  })
}
watch(
  () => props.value,
  (v) => {
    if (!v) {
      data.value = v
      // 处理搜索
      if (searchTxt.value) {
        fetchUser('')
      }
    } else if (Array.isArray(v)) {
      if (JSON.stringify(v) !== JSON.stringify(data.value)) {
        data.value = v
        needFetchValue(v)
      }
    } else if (typeof v === 'string' && v !== data.value) {
      data.value = v
      needFetchValue([v])
    }
  },
  { immediate: true }
)
</script>
